import { Injectable } from '@angular/core';
import {DataService} from '.././data/data.service';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../.././environments/environment';

const url     = 'Admin/api/Auth';
const BaseUrl = environment.BaseUrl

@Injectable({
  providedIn: 'root'
})
export class ForgotPasswordService extends DataService {

  constructor(http: HttpClient) {
    super(url, BaseUrl, http, "");
  }
}
